import React, { useState, useEffect, useContext } from 'react';
import {StatusCode} from 'grpc-web';
import { useMediaQuery } from 'react-responsive';
import PulseLoader from "react-spinners/PulseLoader";

import {AuthContext} from "../contexts/AuthContext";
import SmartPlug from "./SmartPlug"
import { TimeRange, ListSmartPlugsRequest, SmartPlug as SmartPlugDevice } from "../goveeenergymonitoringpb/internal/proto/goveeenergymonitoring_pb"
import { GoveeEnergyMonitoringUIClient } from "../goveeenergymonitoringpb/internal/proto/goveeenergymonitoring_grpc_web_pb"
import {EmailSignin} from "./EmailSignin";
import {ZoomContext} from "../contexts/ZoomContext";
import SmartPlugAggregate from "./SmartPlugAggregate";
// import SmartPlugAggregate from "./SmartPlugAggregate";

const SmartPlugList = () => {
  const [devices, setDevices] = useState([]);
  const [isLoadingDevices, setIsLoadingDevices] = useState(true);
  const [errClassName, setErrClassName] = useState("err-message-hide");
  const [errMessage, setErrMessage] = useState(null);
  const { user, isLoadingUser, fetchUser, getAccessToken } = useContext(AuthContext);
  const { since, until, setCustomTimeRange } = useContext(ZoomContext);

  const client = new GoveeEnergyMonitoringUIClient(process.env.REACT_APP_GRPC_URL);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1124px)'
  });

  const fetchDevices = (isLastTry) => {
    console.log("fetching device list");
    if (isLoadingUser) {
      return;
    }

    const accessToken = getAccessToken();
    const metadata = {"Authorization": "Bearer " + accessToken}
    if (!accessToken) {
      setIsLoadingDevices(false);
      return;
    }

    const req = new ListSmartPlugsRequest();
    req.setTimerange(new TimeRange([since, until]));
    console.log("Fetching list of devices with timeRange", new Date(since), new Date(until), "with token", accessToken);
    
    client.listSmartPlugs(req, metadata, (err, response) => {
      if (err) {
        if (err.code === StatusCode.UNAUTHENTICATED) {
          if (!isLastTry) {
            console.error("Received auth error getting batch of devices, attempting to refresh auth and retry", err)
            fetchUser().then(function() {
              console.log("Refresh attempt complete, retrying device fetch")
              fetchDevices(true);
            });
            return;
          }
        }

        console.error("Received error getting batch of devices", err);
        var message = "An error occurred loading the list of Govee devices";
        if (err && err.message) {
          message += ': "' + err.message + '"';
        }
        message += ". Will retry automatically."
        setErrMessage(message);
        setErrClassName("err-message-show");
        setIsLoadingDevices(false);
      } else {
        const devicesList = response.getSmartPlugsList();
        console.log("Received fresh batch of devices:", devicesList.length)
        setErrClassName("err-message-hide")
        setDevices(devicesList);
        setIsLoadingDevices(false);
      }
    });
  }

  useEffect(() => {
    if (isLoadingUser) {
      return;
    }

    console.log("SmartPlugList: use effect, about to fetch Devices")
    fetchDevices();
  }, [user, isLoadingUser, since, until]);

  const onDragZoom = (left, right) => {
    console.log("onDragZoom, setting custom time range", new Date(left), new Date(right));
    setCustomTimeRange(left, right, "Custom");
  };


  const totalDevice = new SmartPlugDevice();
  totalDevice.setId("total");
  totalDevice.setDisplayName("Total Power Usage");
  
  const charts = devices.map((device, index) => {
    return (
        <li className="device-list-entry" key={device.getId()}>
          <SmartPlug key={device.getId()} client={client} device={device} onDragZoom={onDragZoom} showExpand={true}/>
        </li>
    );
  });

  if (isLoadingUser || isLoadingDevices) {
    return (
        <>
          <div className={errClassName}>{errMessage}</div>
          <div className="device-list">
            <ul>
              <li className="device-list-empty-state">
                <PulseLoader speedMultiplier={0.8} color="#629af0"/>
              </li>
            </ul>
          </div>
        </>
    );
  }

  return (
      <>
        <div className={errClassName}>{errMessage}</div>
        <div className="device-list">
          {!user && <EmailSignin/>}
          <ul>
            {user && charts.length > 0 && <li className="device-list-entry"
                                              key={totalDevice.getId()}>
              <SmartPlugAggregate key={totalDevice.getId()} client={client}
                                  device={totalDevice} onDragZoom={onDragZoom}
                                  showExpand={false}/>
            </li>
            }
            {user && charts.length > 0 && charts}
            {user && charts.length === 0 && (
                <li className="device-list-empty-state">No Govee Smart Plugs found</li>
            )}
          </ul>
        </div>
      </>

  );
};

export default SmartPlugList;
